import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';
import './assets/sass/light-bootstrap-dashboard.css?v=1.1.0';
import indexRoutes from './routes/index.jsx';
import configureStore from './store/configureStore';
import auth from './libCustom/auth';
import feathers from './feathers';

import * as Sentry from '@sentry/browser';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').then(
      function (registration) {
        // Registration was successful
        console.log(
          'ServiceWorker registration successful with scope: ',
          registration.scope
        );
      },
      function (err) {
        // registration failed :(
        console.log('ServiceWorker registration failed: ', err);
      }
    );
  });
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disconnect: true,
      message: 'Esperando conexión',
    };
  }

  componentWillMount() {
    Sentry.init({
      dsn: 'https://39412a974b1a496caef7d93fe779edf9@sentry.io/1391811',
    });

    Sentry.configureScope((scope) => {
      scope.setUser({
        id: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        email:
          auth.getCurrentUser() !== null ? auth.getCurrentUser().email : '',
      });
      scope.setTag(
        'franchiseId',
        auth.getCurrentUser() !== null ? auth.getCurrentUser().franchiseId : ''
      );

      scope.setTag(
        'emailUser',
        auth.getCurrentUser() !== null ? auth.getCurrentUser().email : ''
      );
    });

    feathers.service('users').on('patched', function () {
      // window.location.reload();
    });
  }

  render() {
    return (
      <Provider store={configureStore()}>
        <HashRouter>
          <Switch>
            {indexRoutes.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </HashRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js